const apiRoutes = {
    deliveryAgents: {
        test: 'deliveryAgentsLookupExpress',
        scala: '/delivery-agents',
        express: '/api/delivery-agents',
    },
    postcodeLookup: {
        test: undefined, // already fully on Express
        scala: '/postcode-lookup',
        express: '/api/postcode-lookup',
    },
};
export function apiUrl({ apiRouteKey, param, abParticipations, }) {
    const { test, scala, express } = apiRoutes[apiRouteKey];
    const useExpress = test === undefined || abParticipations?.[test] === 'variant';
    return `${useExpress ? express : scala}/${encodeURIComponent(param)}`;
}
